import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { FechaInput } from 'sharedComponents/inputs/text'

import { KeyEventUtil } from 'utils'

const FechaPagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-monedaPago', e, {
      timeOutTime: 200
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC. PAGO' htmlFor='date-fechaPago' md={4} />
      <Col md={8}>
        <Field name='fechaPago'>
          {({ field }) => (
            <FechaInput
              {...field}
              id='date-fechaPago'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaPagoFormGroup)
